import DeferOC from './DeferOC';

export default DeferOC;
